const nigeriaStatesAndCities = {
    "Northern Nigeria": {
        "North West": {
            "Kano": ["Kano", "Wudil", "Rano", "Gaya", "Bichi", "Tudun Wada", "Gwarzo", "Gezawa"],
            "Kaduna": ["Kaduna", "Zaria", "Kafanchan", "Saminaka", "Kagoro", "Birnin Gwari"],
            "Katsina": ["Katsina", "Daura", "Funtua", "Malumfashi", "Dutsin-Ma", "Kankia"],
            "Sokoto": ["Sokoto", "Wurno", "Tambuwal", "Illela", "Goronyo", "Gwadabawa"],
            "Kebbi": ["Birnin Kebbi", "Argungu", "Yauri", "Zuru", "Kamba", "Bagudo"],
            "Zamfara": ["Gusau", "Kaura Namoda", "Talata Mafara", "Gummi", "Maru", "Anka"],
            "Jigawa": ["Dutse", "Hadejia", "Gumel", "Kazaure", "Ringim", "Birnin Kudu"]
        },
        "North East": {
            "Borno": ["Maiduguri", "Biu", "Bama", "Gwoza", "Monguno", "Damboa", "Konduga"],
            "Yobe": ["Damaturu", "Potiskum", "Nguru", "Gashua", "Geidam", "Fika"],
            "Adamawa": ["Yola", "Mubi", "Jimeta", "Numan", "Ganye", "Hong", "Michika"],
            "Bauchi": ["Bauchi", "Azare", "Misau", "Jama'are", "Katagum", "Dass", "Alkaleri"],
            "Gombe": ["Gombe", "Kaltungo", "Bajoga", "Dukku", "Billiri", "Nafada"],
            "Taraba": ["Jalingo", "Wukari", "Takum", "Gembu", "Karim Lamido", "Bali"]
        },
        "North Central": {
            "Niger": ["Minna", "Bida", "Suleja", "Kontagora", "Mokwa", "Lapai", "Agaie"],
            "Kogi": ["Lokoja", "Okene", "Kabba", "Idah", "Ankpa", "Ajaokuta", "Dekina"],
            "Benue": ["Makurdi", "Otukpo", "Gboko", "Katsina-Ala", "Vandeikya", "Okpokwu"],
            "Kwara": ["Ilorin", "Offa", "Jebba", "Omu-Aran", "Lafiagi", "Patigi"],
            "Plateau": ["Jos", "Barkin Ladi", "Pankshin", "Shendam", "Langtang", "Mangu"],
            "Nasarawa": ["Lafia", "Keffi", "Akwanga", "Nasarawa", "Toto", "Doma"],
            "Abuja": ["Abuja", "Gwagwalada", "Kuje", "Bwari", "Abaji"]
        }
    },
    "Southern Nigeria": {
        "South West": {
            "Lagos": ["Lagos", "Ikeja", "Epe", "Ikorodu", "Badagry", "Ajah", "Victoria Island"],
            "Ogun": ["Abeokuta", "Ijebu-Ode", "Sango Ota", "Sagamu", "Ilaro", "Owode"],
            "Oyo": ["Ibadan", "Ogbomosho", "Oyo", "Saki", "Iseyin", "Eruwa"],
            "Osun": ["Osogbo", "Ife", "Ilesa", "Ede", "Ikirun", "Iwo", "Ejigbo"],
            "Ondo": ["Akure", "Ondo", "Owo", "Ikare", "Okitipupa", "Ilaje"],
            "Ekiti": ["Ado-Ekiti", "Ikere-Ekiti", "Ijero-Ekiti", "Oye", "Ikole", "Aramoko"]
        },
        "South South": {
            "Rivers": ["Port Harcourt", "Bonny", "Omoku", "Eleme", "Bori", "Okrika", "Ahoada"],
            "Bayelsa": ["Yenagoa", "Brass", "Ogbia", "Sagbama", "Kaiama", "Nembe"],
            "Delta": ["Asaba", "Warri", "Sapele", "Agbor", "Ughelli", "Isoko", "Burutu"],
            "Edo": ["Benin City", "Auchi", "Uromi", "Ekpoma", "Irrua", "Agenebode"],
            "Akwa Ibom": ["Uyo", "Ikot Ekpene", "Eket", "Oron", "Abak", "Itu", "Uruan"],
            "Cross River": ["Calabar", "Ikom", "Ugep", "Ogoja", "Akpabuyo", "Obudu"]
        },
        "South East": {
            "Abia": ["Umuahia", "Aba", "Ohafia", "Arochukwu", "Bende", "Isuikwuato"],
            "Anambra": ["Awka", "Onitsha", "Nnewi", "Ekwulobia", "Ihiala", "Otuocha"],
            "Ebonyi": ["Abakaliki", "Afikpo", "Onueke", "Ikwo", "Izzi", "Ohaozara"],
            "Enugu": ["Enugu", "Nsukka", "Udi", "Agbani", "Oji River", "Ezeagu"],
            "Imo": ["Owerri", "Orlu", "Okigwe", "Mbaise", "Oguta", "Njaba"]
        }
    }
};

export default nigeriaStatesAndCities;
